import React, { lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import BarraNavegacion from "Componentes/BarraNavegacion";
import DashBoard from "DashBoard/DashBoard";
import PartesTrabajoDetalle from "PartesTrabajo/PartesTrabajoDetalle";
import Login from "Login/Login";
// import { peticionGet } from "Componentes/ComponenteAxios";

// Definición de rutas protegidas con lazy load
const rutasProtegidas = [
  {
    base: "Almacenes",
    listado: lazy(() => import("Almacenes/AlmacenListado")),
    nuevo: lazy(() => import("Almacenes/AlmacenNuevo")),
    edicion: lazy(() => import("Almacenes/AlmacenEdicion")),
  },
  {
    base: "Buques",
    listado: lazy(() => import("Buques/BuqueListado")),
    nuevo: lazy(() => import("Buques/BuqueNuevo")),
    edicion: lazy(() => import("Buques/BuqueEdicion")),
  },
  {
    base: "Clientes",
    listado: lazy(() => import("Clientes/ClienteListado")),
    nuevo: lazy(() => import("Clientes/ClienteNuevo")),
    edicion: lazy(() => import("Clientes/ClienteEdicion")),
  },
  {
    base: "Colla",
    listado: lazy(() => import("PersonalColla/PersonalCollaListado")),
  },
  {
    base: "Consignatarios",
    listado: lazy(() => import("Consignatarios/ConsignatarioListado")),
    nuevo: lazy(() => import("Consignatarios/ConsignatarioNuevo")),
    edicion: lazy(() => import("Consignatarios/ConsignatarioEdicion")),
  },
  {
    base: "Informes/Arrastres",
    listado: lazy(() => import("Informes/Arrastres")),
  },
  {
    base: "Informes/CostesDirectos",
    listado: lazy(() => import("Informes/CostesDirectos")),
  },
  {
    base: "Informes/PorOperacion",
    listado: lazy(() => import("Informes/PorOperacion")),
  },
  {
    base: "Informes/PorJornada",
    listado: lazy(() => import("Informes/PorJornada")),
  },
  {
    base: "Informes/Tasas",
    listado: lazy(() => import("Informes/Tasas")),
  },
  {
    base: "Informes/Maquinaria",
    listado: lazy(() => import("Informes/Maquinaria")),
  },
  {
    base: "Informes/PersonalAgrupado",
    listado: lazy(() => import("Informes/PersonalAgrupado")),
  },
  {
    base: "Informes/PersonalIndividual",
    listado: lazy(() => import("Informes/PersonalIndividual")),
  },
  {
    base: "Jornadas",
    listado: lazy(() => import("Jornadas/JornadaListado")),
    nuevo: lazy(() => import("Jornadas/JornadaNuevo")),
    edicion: lazy(() => import("Jornadas/JornadaEdicion")),
  },
  {
    base: "MediosMecanicos",
    listado: lazy(() => import("MediosMecanicos/MediosMecanicosListado")),
    nuevo: lazy(() => import("MediosMecanicos/MediosMecanicosNuevo")),
    edicion: lazy(() => import("MediosMecanicos/MediosMecanicosEdicion")),
  },
  {
    base: "Mercancias",
    listado: lazy(() => import("Mercancias/MercanciasListado")),
    nuevo: lazy(() => import("Mercancias/MercanciasNuevo")),
    edicion: lazy(() => import("Mercancias/MercanciasEdicion")),
  },
  {
    base: "Operaciones",
    listado: lazy(() => import("Operaciones/Listado")),
    nuevo: lazy(() => import("Operaciones/Nuevo")),
    edicion: lazy(() => import("Operaciones/Edicion")),
    editarCabecera: lazy(() => import("Operaciones/EditarCabecera")),
  },
  {
    base: "OrigenDestino",
    listado: lazy(() => import("OrigenDestino/OrigenDestinoListado")),
    nuevo: lazy(() => import("OrigenDestino/OrigenDestinoNuevo")),
    edicion: lazy(() => import("OrigenDestino/OrigenDestinoEdicion")),
  },
  {
    base: "CostesDirectos",
    listado: lazy(() => import("CostesDirectos/CostesDirectosListado")),
    nuevo: lazy(() => import("CostesDirectos/CostesDirectosNuevo")),
    edicion: lazy(() => import("CostesDirectos/CostesDirectosEdicion")),
  },
  {
    base: "Operativas",
    listado: lazy(() => import("Operativas/Listado")),
    nuevo: lazy(() => import("Operativas/Nuevo")),
    edicion: lazy(() => import("Operativas/Edicion")),
  },
  {
    base: "PersonalPrimeraLinea",
    listado: lazy(() => import("PersonalPrimeraLinea/PersonalPrimeraLineaListado")),
  },
  {
    base: "PersonalSegundaLinea",
    listado: lazy(() => import("PersonalSegundaLinea/PersonalSegundaLineaListado")),
  },
  {
    base: "Pluses",
    listado: lazy(() => import("Pluses/Listado")),
  },
  {
    base: "Proveedores",
    listado: lazy(() => import("Proveedores/Listado")),
    nuevo: lazy(() => import("Proveedores/Nuevo")),
    edicion: lazy(() => import("Proveedores/Edicion")),
  },
  {
    base: "Tarifas",
    listado: lazy(() => import("Tarifas/TarifasListado")),
    nuevo: lazy(() => import("Tarifas/TarifasNuevo")),
    edicion: lazy(() => import("Tarifas/TarifasEdicion")),
  },
];

// Componente de ruta protegida

const ProtectedRoute = ({ children }) => {

  const token = localStorage.getItem("tokenCadevesaCostes");

  const handleLogout = () => {
    localStorage.removeItem("tokenCadevesaCostes");
    window.location.href = "/login";
  };

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <BarraNavegacion onLogout={handleLogout} />
      <div style={{ marginTop: "20px" }}>{children}</div>
    </>
  );
};

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        {/* Ruta principal protegida */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashBoard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/PartesTrabajoDetalle/:id"
          element={
            <ProtectedRoute>
              <PartesTrabajoDetalle />
            </ProtectedRoute>
          }
        />

        {/* Rutas protegidas generadas dinámicamente */}
        {rutasProtegidas.map(({ base, listado, nuevo, edicion, editarCabecera }) => (
          <React.Fragment key={base}>
            <Route
              path={`/${base}`}
              element={
                <ProtectedRoute>{React.createElement(listado)}</ProtectedRoute>
              }
            />
            <Route
              path={`/${base}/Nuevo`}
              element={
                <ProtectedRoute>{React.createElement(nuevo)}</ProtectedRoute>
              }
            />
            <Route
              path={`/${base}/Editar/:id`}
              element={
                <ProtectedRoute>{React.createElement(edicion)}</ProtectedRoute>
              }
            />
            {editarCabecera && (
              <Route
                path={`/${base}/EditarCabecera/:id`}
                element={
                  <ProtectedRoute>{React.createElement(editarCabecera)}</ProtectedRoute>
                }
              />
            )}


          </React.Fragment>
        ))}
      </Routes>
    </Router>
  );
};

export default AppRoutes;